import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const sectionStorePartnerContactStyles = {
  icon: (): SystemStyleObject<Theme> => ({
    cursor: "pointer",
    fontSize: 16,
  }),
};

export default sectionStorePartnerContactStyles;
